// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Support_featured__SvnTI {
    margin-top: 28px;
}
.Support_featuredTitle__iRAVv {
    font-style: normal;
    font-weight: 700;
    font-size: 38px;
    line-height: 75px;
    text-align: center;
    margin: 0;
    font-family: 'Cocon Bold', sans-serif;
}
.Support_featured__SvnTI button {
    background-color: #69bf4a;
    width: 28%;
    text-align: center;
    padding: 12px;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;
    font-family: 'Cocon Bold', sans-serif;
    cursor: pointer;
    margin: 50px auto;
    cursor: pointer !important;
    border: 1px solid transparent;
    min-width: 250px ;
}
.Support_featured__SvnTI button:hover {
    transition: 0.5s;
    transform: scale(1.1);
    box-shadow: 10px 10px 0 #FBC638;
}


.Support_teamBrands__hkWxf {
    width: 90%;
    display: flex;
    gap: 20px;
    margin: 0 auto;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;
}
.Support_brandImg__Dtt0k {
    padding: 1em;
    height: 100px;
}
.Support_brandImg__Dtt0k:hover {
    transition: 0.5s;
    transform: scale(1.1);
    box-shadow: 0px 0px 30px 15px #0000002b;
}


.Support_journeyButton__6fHl4 {
    background-color: #69bf4a;
    width: 33%;
    text-align: center;
    padding: 12px;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;
    font-family: 'Cocon Bold', sans-serif;
    cursor: pointer;
    margin: 50px auto;
    cursor: pointer !important;
    z-index: 999;
}

.Support_buttonArrow__3dYJu {
    margin-left: 10px;
    width: 36px;
}
.Support_glowGreen__-5RtR {
    box-shadow: 0 0 30px #00ff00;
}
.Support_glowBlue__DCJdC {
    box-shadow: 0 0 30px #00ffff;
}

.Support_bg3__3NfjW {
    background-image: linear-gradient(to right, #1ecec9, #69be49);
    padding: 0px 0 0px 30px;
    display: flex;
    height: 450px;
}
.Support_bg3__3NfjW p {
    padding-left: 10%;
}


.Support_supportPanel__Ti3Md {
    position: relative;
    width: 50%;
}
.Support_supportText__BkWok {
    font-size: 80px;
    font-weight: 600;
    font-family: 'Cocon Bold', sans-serif;
    color: #fff;
    margin: 0;
}
.Support_supportText__BkWok span {
    font-size: 40px;
    font-weight: 200;
    font-family: sans-serif;
}
.Support_supportSubtext__c4DSd {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
    padding: 25px 0;
}
.Support_supportSubtext__c4DSd span {
    font-size: 24px;
    font-weight: 400;
    margin: 0;
}


.Support_imagePanel__FSTpg {
    position: relative;
}
.Support_supportImg__ROK09 {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 795px;
}



.Support_meetOurTeam__vnAi4 {
    position: relative;
    top: -48px;
    height: 11px;
}
.Support_meetButtonBox__vMLds {
    display: flex;
    justify-content: flex-end;
}
.Support_meetButton__xNpiU {
    background-color: #1dcec9;
    min-width: 225px;
    padding: 10px 23px 0;
    text-align: center;
    padding: 12px 12px 0;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    border-radius: 65px 65px 0px 0px;
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: flex-end;
    font-family: 'Cocon Bold', sans-serif;
    cursor: pointer;
    margin: 0;
    margin-right: 111px;
}
.Support_blueBar__YskVN {
    height: 14px;
    background-color: #1dcec9;
    background: linear-gradient(to left, #1dcec9, transparent);
}

@media screen and (max-width: 1492px) {
    .Support_supportText__BkWok {
        font-size: 60px;
    }
}
@media screen and (max-width: 1314px) {
    .Support_meetOurTeam__vnAi4 {
        top: -53px;
    }
    .Support_supportText__BkWok {
        font-size: 48px;
    }
    .Support_supportText__BkWok span {
        font-size: 30px;
    }
}
@media screen and (max-width: 992px) {
    .Support_featured__SvnTI button{
        width: 68%;
    }
    .Support_journeyButton__6fHl4 {
        margin: 20px auto;
        width: 49%;
    }
    .Support_bg3__3NfjW {
        height: auto;
        padding-bottom: 60px;
    }
    .Support_meetButtonBox__vMLds {
        justify-content: center;
    }
    .Support_meetButton__xNpiU {
        margin: 0 auto;
        border-radius: 65px;
        padding: 12px;
    
    }
    .Support_meetOurTeam__vnAi4 {
        top: -75px;
        height: auto;
    }
    .Support_blueBar__YskVN {
        display: none;
    }
    .Support_supportImg__ROK09 {
        display: none;
    }    
    .Support_imagePanel__FSTpg {
        display: none;
        width: 0%;
    }
    .Support_supportPanel__Ti3Md {
        width: 90%;
        margin: 0 auto;
    }
}
@media screen and (max-width: 768px) {
    .Support_teamBrands__hkWxf {
        width: 98%;
        display: flex;
        gap: 10px;
        margin: 0 auto;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }
    .Support_brandImg__Dtt0k {
        height: 50px;
    }
    .Support_journeyButton__6fHl4 {
        margin: 15px auto;
        width: 68%;
        font-size: 20px;
    }
    .Support_supportText__BkWok {
        font-size: 32px;
    }
    .Support_supportText__BkWok span {
        font-size: 18px;
    }
    .Support_supportSubtext__c4DSd {
        font-size: 24px;
    }
    .Support_supportSubtext__c4DSd span {
        font-size: 18px;
    }
}
@media screen and (max-width: 350px) {
    .Support_featuredTitle__iRAVv {
        font-size: 24px;
        line-height: 45px;  
    }
    .Support_buttonArrow__3dYJu {
        width: 25px;
    }
    .Support_supportText__BkWok {
        font-size: 24px;
    }
    .Support_supportSubtext__c4DSd {
        font-size: 18px;
    }
    .Support_meetButtonBox__vMLds {
        justify-content: center;
    }
    .Support_meetButton__xNpiU {
        font-size: 16px;
        min-width: 0px;
    }
    .Support_journeyButton__6fHl4 {
        padding: 8px;
        font-size: 16px;
        gap: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Landing/Support.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,qCAAqC;AACzC;AACA;IACI,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,+BAA+B;AACnC;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,SAAS;IACT,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,uCAAuC;AAC3C;;;AAGA;IACI,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,6DAA6D;IAC7D,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;;AAGA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;;;AAIA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,qCAAqC;IACrC,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,0DAA0D;AAC9D;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,iBAAiB;QACjB,UAAU;IACd;IACA;QACI,YAAY;QACZ,oBAAoB;IACxB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,cAAc;QACd,mBAAmB;QACnB,aAAa;;IAEjB;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,SAAS;IACb;IACA;QACI,UAAU;QACV,cAAc;IAClB;AACJ;AACA;IACI;QACI,UAAU;QACV,aAAa;QACb,SAAS;QACT,cAAc;QACd,eAAe;QACf,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,UAAU;QACV,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,YAAY;QACZ,eAAe;QACf,QAAQ;IACZ;AACJ","sourcesContent":[".featured {\n    margin-top: 28px;\n}\n.featuredTitle {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 38px;\n    line-height: 75px;\n    text-align: center;\n    margin: 0;\n    font-family: 'Cocon Bold', sans-serif;\n}\n.featured button {\n    background-color: #69bf4a;\n    width: 28%;\n    text-align: center;\n    padding: 12px;\n    color: #fff;\n    font-weight: bold;\n    font-size: 24px;\n    border-radius: 25px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    justify-content: center;\n    font-family: 'Cocon Bold', sans-serif;\n    cursor: pointer;\n    margin: 50px auto;\n    cursor: pointer !important;\n    border: 1px solid transparent;\n    min-width: 250px ;\n}\n.featured button:hover {\n    transition: 0.5s;\n    transform: scale(1.1);\n    box-shadow: 10px 10px 0 #FBC638;\n}\n\n\n.teamBrands {\n    width: 90%;\n    display: flex;\n    gap: 20px;\n    margin: 0 auto;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-evenly;\n    cursor: pointer;\n}\n.brandImg {\n    padding: 1em;\n    height: 100px;\n}\n.brandImg:hover {\n    transition: 0.5s;\n    transform: scale(1.1);\n    box-shadow: 0px 0px 30px 15px #0000002b;\n}\n\n\n.journeyButton {\n    background-color: #69bf4a;\n    width: 33%;\n    text-align: center;\n    padding: 12px;\n    color: #fff;\n    font-weight: bold;\n    font-size: 24px;\n    border-radius: 25px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    justify-content: center;\n    font-family: 'Cocon Bold', sans-serif;\n    cursor: pointer;\n    margin: 50px auto;\n    cursor: pointer !important;\n    z-index: 999;\n}\n\n.buttonArrow {\n    margin-left: 10px;\n    width: 36px;\n}\n.glowGreen {\n    box-shadow: 0 0 30px #00ff00;\n}\n.glowBlue {\n    box-shadow: 0 0 30px #00ffff;\n}\n\n.bg3 {\n    background-image: linear-gradient(to right, #1ecec9, #69be49);\n    padding: 0px 0 0px 30px;\n    display: flex;\n    height: 450px;\n}\n.bg3 p {\n    padding-left: 10%;\n}\n\n\n.supportPanel {\n    position: relative;\n    width: 50%;\n}\n.supportText {\n    font-size: 80px;\n    font-weight: 600;\n    font-family: 'Cocon Bold', sans-serif;\n    color: #fff;\n    margin: 0;\n}\n.supportText span {\n    font-size: 40px;\n    font-weight: 200;\n    font-family: sans-serif;\n}\n.supportSubtext {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n    padding: 25px 0;\n}\n.supportSubtext span {\n    font-size: 24px;\n    font-weight: 400;\n    margin: 0;\n}\n\n\n.imagePanel {\n    position: relative;\n}\n.supportImg {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 795px;\n}\n\n\n\n.meetOurTeam {\n    position: relative;\n    top: -48px;\n    height: 11px;\n}\n.meetButtonBox {\n    display: flex;\n    justify-content: flex-end;\n}\n.meetButton {\n    background-color: #1dcec9;\n    min-width: 225px;\n    padding: 10px 23px 0;\n    text-align: center;\n    padding: 12px 12px 0;\n    color: #fff;\n    font-weight: bold;\n    font-size: 24px;\n    border-radius: 65px 65px 0px 0px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    justify-content: flex-end;\n    font-family: 'Cocon Bold', sans-serif;\n    cursor: pointer;\n    margin: 0;\n    margin-right: 111px;\n}\n.blueBar {\n    height: 14px;\n    background-color: #1dcec9;\n    background: linear-gradient(to left, #1dcec9, transparent);\n}\n\n@media screen and (max-width: 1492px) {\n    .supportText {\n        font-size: 60px;\n    }\n}\n@media screen and (max-width: 1314px) {\n    .meetOurTeam {\n        top: -53px;\n    }\n    .supportText {\n        font-size: 48px;\n    }\n    .supportText span {\n        font-size: 30px;\n    }\n}\n@media screen and (max-width: 992px) {\n    .featured button{\n        width: 68%;\n    }\n    .journeyButton {\n        margin: 20px auto;\n        width: 49%;\n    }\n    .bg3 {\n        height: auto;\n        padding-bottom: 60px;\n    }\n    .meetButtonBox {\n        justify-content: center;\n    }\n    .meetButton {\n        margin: 0 auto;\n        border-radius: 65px;\n        padding: 12px;\n    \n    }\n    .meetOurTeam {\n        top: -75px;\n        height: auto;\n    }\n    .blueBar {\n        display: none;\n    }\n    .supportImg {\n        display: none;\n    }    \n    .imagePanel {\n        display: none;\n        width: 0%;\n    }\n    .supportPanel {\n        width: 90%;\n        margin: 0 auto;\n    }\n}\n@media screen and (max-width: 768px) {\n    .teamBrands {\n        width: 98%;\n        display: flex;\n        gap: 10px;\n        margin: 0 auto;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: center;\n    }\n    .brandImg {\n        height: 50px;\n    }\n    .journeyButton {\n        margin: 15px auto;\n        width: 68%;\n        font-size: 20px;\n    }\n    .supportText {\n        font-size: 32px;\n    }\n    .supportText span {\n        font-size: 18px;\n    }\n    .supportSubtext {\n        font-size: 24px;\n    }\n    .supportSubtext span {\n        font-size: 18px;\n    }\n}\n@media screen and (max-width: 350px) {\n    .featuredTitle {\n        font-size: 24px;\n        line-height: 45px;  \n    }\n    .buttonArrow {\n        width: 25px;\n    }\n    .supportText {\n        font-size: 24px;\n    }\n    .supportSubtext {\n        font-size: 18px;\n    }\n    .meetButtonBox {\n        justify-content: center;\n    }\n    .meetButton {\n        font-size: 16px;\n        min-width: 0px;\n    }\n    .journeyButton {\n        padding: 8px;\n        font-size: 16px;\n        gap: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featured": `Support_featured__SvnTI`,
	"featuredTitle": `Support_featuredTitle__iRAVv`,
	"teamBrands": `Support_teamBrands__hkWxf`,
	"brandImg": `Support_brandImg__Dtt0k`,
	"journeyButton": `Support_journeyButton__6fHl4`,
	"buttonArrow": `Support_buttonArrow__3dYJu`,
	"glowGreen": `Support_glowGreen__-5RtR`,
	"glowBlue": `Support_glowBlue__DCJdC`,
	"bg3": `Support_bg3__3NfjW`,
	"supportPanel": `Support_supportPanel__Ti3Md`,
	"supportText": `Support_supportText__BkWok`,
	"supportSubtext": `Support_supportSubtext__c4DSd`,
	"imagePanel": `Support_imagePanel__FSTpg`,
	"supportImg": `Support_supportImg__ROK09`,
	"meetOurTeam": `Support_meetOurTeam__vnAi4`,
	"meetButtonBox": `Support_meetButtonBox__vMLds`,
	"meetButton": `Support_meetButton__xNpiU`,
	"blueBar": `Support_blueBar__YskVN`
};
export default ___CSS_LOADER_EXPORT___;
